import VueScrollTo from 'vue-scrollto'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa, faCcMastercard, faCcAmex } from '@fortawesome/free-brands-svg-icons'
import { faCreditCard, faShoppingCart, faCheck, faExclamation, faTimes, faLock, faCog, faInfo } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import logSomnambulistState from 'src/utils/logSomnambulistState'
const store = () => import(/* webpackChunkName: 'somnambulist-ui-store' */ './store')
const SomnambulistUI = () => import(/* webpackChunkName: 'somnambulist-ui' */ './SomnambulistUI')

// Guarded here (not inside logSomnambulistState) so Terser can eliminate
// the whole call, including every JSON.stringify inside it, when
// DEBUG_LOGGING is off - it can't see through an imported function call to
// know its body is otherwise a no-op.
const logSomnambulistStateIfEnabled = function(newStore, label) {
  if (!process.env.DEBUG_LOGGING) return
  logSomnambulistState(newStore.state.somnambulistui, label)
}

const loadSomnambulistStore = function(newStore, googleAddressesAPIKey, ecommerce, logger) {
  if (!newStore.hasModule('somnambulistui')) {
    return store().then((storeImport) => {
      newStore.registerModule('somnambulistui', storeImport.default, { preserveState: newStore.state.somnambulistui !== undefined })
      newStore.commit('somnambulistui/STORE_GOOGLE_ADDRESSES_APIKEY', googleAddressesAPIKey)
      let p = Promise.resolve(true)
      if (ecommerce) {
        p = newStore.dispatch('ecommerce/init', { wait: true, txntype: 'somnambulist' })
      }
      return p.then(_ => newStore.dispatch('somnambulistui/init'))
        .then(_ => {
          logger.log('Somnambulist init prefetch complete')
          logSomnambulistStateIfEnabled(newStore, 'post-init')
        })
    })
  }

  return newStore.dispatch('somnambulistui/reinit')
    .then(_ => {
      logSomnambulistStateIfEnabled(newStore, 'post-reinit')
    })
}

function install(Vue, options) {
  if (options.lazyStore === undefined || options.lazyStore === false) {
    if (!options.store) {
      throw new Error('Please register the Somnambulist UI Plugin by passing a Vuex Store')
    }
    store().then((storeImport) => {
      options.store.registerModule('somnambulistui', storeImport.default, { preserveState: options.store.state.somnambulistui !== undefined })
      options.store.commit('somnambulistui/STORE_GOOGLE_ADDRESSES_APIKEY', options.googleAddressesAPIKey)
    })
  }
  library.add(faCreditCard, faShoppingCart, faCheck, faExclamation, faCcVisa, faCcMastercard, faCcAmex, faTimes, faUser, faLock, faCog, faInfo)
  Vue.use(VueScrollTo)
  Vue.filter('formatEntities', val => {
    if (!val) return ''
    return val.replace(/&#039;/g, "'")
  })

  Vue.filter('toPrice', (value) => {
    if (typeof value === 'number') {
      return '$' + value.toFixed(2)
    }
    else {
      return '$' + parseFloat(value).toFixed(2)
    }
  })

  const waitForRouter = resolve => {
    const router = options.router()
    if (router) {
      return resolve(router)
    }
    setTimeout(() => waitForRouter(resolve))
  }

  // Wait for the router to initialise
  new Promise(waitForRouter).then(router => {
    router.beforeEach((to, from, next) => {
      if (
        (typeof localStorage === 'undefined' || !localStorage.getItem('somnambulistSelectedOrder')) ||
        !options.store.getters['user/isLoggedIn'] ||
        router.currentRoute.path === options.clubPath ||
        to.path === options.clubPath ||
        from.path !== '/signup'
      ) {
        return next()
      }

      next(options.clubPath)
    })
  })

  Vue.prototype.$eventHub.$on('loginComplete', () => {
    if (options.store.hasModule('somnambulistui')) {
      options.store.dispatch('somnambulistui/reinit')
    }
  })
}

export default { SomnambulistUI, install, store, loadSomnambulistStore }
